module.exports = __webpack_public_path__ + "img/screen-sharing.6fd5a062.svg";